import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';

// 1. Kütüphane Stilleri
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'remixicon/fonts/remixicon.css';

// 2. Kendi Stillerin (Kütüphane stillerini ezebilmesi için en altta)
import './index.css';

// 3. Bileşenler ve Konfigürasyonlar
import App from './App';
import { initI18n } from './i18n'; // import './i18n' yerine bunu kullan
import reportWebVitals from './reportWebVitals';



const root = ReactDOM.createRoot(document.getElementById('root'));

// Uygulamayı i18n konfigürasyonu bittikten sonra başlat
initI18n().then(() => {
  root.render(
    <Router future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}>
      <App />
    </Router>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
